"use client";

import { motion as m } from "motion/react";
import NextLink from "next/link";

import { LayoutSideMenuItem } from "@/types";

import { Text } from "@/components/ui/text";
import { Icon } from "@/components/ui/icon";

import { SideMenuReturnVariantProps } from "./side-menu.variants";

export type SideMenuGroupProps = {
  data: LayoutSideMenuItem;
  styles: SideMenuReturnVariantProps;
  onToggleDropdown: (slug: string) => void;
  activeSection: string;
  onHandleMenu?: (active: boolean) => void;
};

function SideMenuGroup(props: SideMenuGroupProps) {
  const { data, styles, onToggleDropdown, activeSection, onHandleMenu } = props;
  const { menuLabel, menu, slug, isOpened } = data;

  return (
    <li>
      <button
        type="button"
        className={styles.dropdownTrigger()}
        onClick={() => onToggleDropdown(slug)}
      >
        <Text tag="span" size="bodyMedium">
          {menuLabel}
        </Text>
        <m.span
          initial={{ rotate: 0 }}
          animate={{ rotate: isOpened ? 180 : 0 }}
          transition={{ duration: 0.25, ease: "easeInOut" }}
        >
          <Icon name="chevron_down" className={styles.dropdownTriggerIcon()} />
        </m.span>
      </button>
      <m.ul
        className={styles.dropdown()}
        initial={{ height: 0, opacity: 0 }}
        animate={{
          height: isOpened ? "auto" : 0,
          opacity: isOpened ? 1 : 0,
        }}
        transition={{ duration: 0.25, ease: "easeInOut" }}
      >
        {menu.map((item) => (
          <li key={item.anchor}>
            <NextLink
              href={`/${item.anchor}`}
              aria-current={
                activeSection === item.anchor.split("#")[1] ? true : undefined
              }
              title={item.menuLabel}
              className={styles.dropdownItem()}
              onClick={() => onHandleMenu?.(false)}
            >
              {item.menuLabel}
            </NextLink>
          </li>
        ))}
      </m.ul>
    </li>
  );
}

export default SideMenuGroup;
